var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1837_1002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 0C6.28091 0 0 6.28091 0 14C0 21.7191 6.28091 28 14 28C21.7191 28 28 21.7191 28 14C28 6.28091 21.7191 0 14 0ZM15.2727 19.2525C15.2727 19.9551 14.7038 20.5253 14 20.5253C13.2962 20.5253 12.7273 19.9551 12.7273 19.2525V12.8889C12.7273 12.1864 13.2962 11.6162 14 11.6162C14.7038 11.6162 15.2727 12.1864 15.2727 12.8889V19.2525ZM15.2727 9.12927C15.2727 9.83182 14.7038 10.402 14 10.402C13.2962 10.402 12.7273 9.83182 12.7273 9.12927V8.74745C12.7273 8.04491 13.2962 7.47473 14 7.47473C14.7038 7.47473 15.2727 8.04491 15.2727 8.74745V9.12927Z",
    fill: "#5C37C0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1837_1002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.f77c04372a22b8d13b4065300931f0b7.svg";
export { ForwardRef as ReactComponent };